(function () {
    'use strict';

    angular
        .module('app.shared')
        .factory('geniusRedirect', geniusRedirect);

    var parser = document.createElement('a');

    geniusRedirect.$inject = ['$window', 'OpenId', 'user', 'culture', 'alert', 'shared_resources'];
    function geniusRedirect($window, OpenId, user, culture, alert, resources) {

        return function geniusRedirect(openInNewWindow, uri) {
            var href = 'https://www.golfgenius.com/sso_gg',                
                newWindow;
            
            redirect();            

            function redirect() {
                if (openInNewWindow) {
                    newWindow = $window.open('', '_blank');
                    newWindow.document.write("Loading...");
                }

                OpenId.getGeniusToken({ url: uri }, success, error, true);
 
            }

            function success(data) {
                parser.href = href;
                parser.search += (parser.search ? '&' : '?') + 'token=' + encodeURIComponent(data.token);
                if (openInNewWindow)
                    newWindow.location.href = parser.href;
                else
                    $window.location.href = parser.href;
            }
            function error() {
                if (newWindow)
                    newWindow.close();
                alert.error(resources.ngnTokenRequestFailed);
            }
        }
    }
})();
